import React from 'react'

export const Trending = () => {
  return (
    <div>Trending</div>
  )
}
